<template>
  <div class="bg">
    <div class="wrapper flex vux-1px-b">
      <div class="imgBox">
        <img
          src="//img4.imgtn.bdimg.com/it/u=1761250919,1896060533&fm=26&gp=0.jpg"
        />
      </div>
      <div class="flex1">
        <div class="title">
          <span class="left">循环油</span>
          <span class="right state">待审核</span>
        </div>
        <div class="price">
          <span class="left">单价</span>
          <span class="right">￥5200/桶</span>
        </div>
        <div class="amount">
          <span class="left">数量</span>
          <span class="right">2</span>
        </div>
      </div>
    </div>
    <div class="vux-1px-b">
      <selector
        title="分配加油船"
        class="selector"
        v-model="params.ship"
        direction="rtl"
        :options="shipList"
      ></selector>
    </div>
    <group title="联系信息">
      <description-list>
        <description-list-item term="联系人">赵鑫盈</description-list-item>
        <description-list-item term="联系电话"
          >15757468761</description-list-item
        >
        <description-list-item term="渔船">浙奉渔256401</description-list-item>
        <description-list-item term="用油时间"
          >2019-12-20</description-list-item
        >
        <description-list-item term="用油地址"
          >浙江省宁波市奉化区1260号</description-list-item
        >
        <description-list-item term="备注">1111</description-list-item>
      </description-list>
    </group>
    <group title="业务员信息">
      <description-list>
        <description-list-item term="渔船">奚松挺</description-list-item>
        <description-list-item term="联系方式"
          >18965012403</description-list-item
        >
      </description-list>
    </group>
    <group title="订单信息">
      <description-list>
        <description-list-item term="订单编号"
          >gy0000000001</description-list-item
        >
        <description-list-item term="下单时间"
          >2019-12-14 08:10:23</description-list-item
        >
        <description-list-item term="完成时间"
          >2019-12-23 15:12:42</description-list-item
        >
        <description-list-item term="说明"></description-list-item>
        <!--<description-list-item term="凭证信息">-->
        <!--</description-list-item>-->
        <!--<div>-->
        <!--<img class="img" src="//img4.imgtn.bdimg.com/it/u=1761250919,1896060533&fm=26&gp=0.jpg" />-->
        <!--</div>-->
      </description-list>
    </group>
    <div class="footBox flex">
      <div class="flex1">拒绝</div>
      <div class="flex2 genjin">跟进</div>
    </div>
  </div>
</template>

<script>
import {
  DescriptionList,
  DescriptionListItem
} from "@/components/DescriptionList";
export default {
  name: "pending",
  components: { DescriptionList, DescriptionListItem },
  data() {
    return {
      params: {
        ship: ""
      },
      shipList: [
        {
          key: "浙奉渔1111",
          value: "浙奉渔1111"
        },
        {
          key: "浙奉渔1221",
          value: "浙奉渔1221"
        }
      ]
    };
  }
};
</script>

<style scoped>
.bg {
  font-size: 14px;
  background: #fff;
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
.flex2 {
  flex: 2;
}
.wrapper {
  padding: 20px 30px;
}
.imgBox {
  width: 200px;
  height: 200px;
  overflow: hidden;
  margin-right: 30px;
}
.imgBox img {
  width: 100%;
  height: 100%;
  display: block;
}
.left {
  float: left;
}
.right {
  float: right;
}
.state {
  color: red;
}
.title,
.price,
.amount {
  clear: both;
  font-size: 14px;
  height: 50px;
  line-height: 50px;
}
.img {
  width: 100px;
  height: 100px;
}
.footBox {
  position: fixed;
  width: 100%;
  height: 100px;
  line-height: 100px;
  bottom: 0;
  left: 0;
  z-index: 1;
  text-align: center;
  background: #fff;
}
.genjin {
  background: #039df8;
  color: #fff;
}
</style>
